import { createRouter, createWebHashHistory } from "vue-router";

const routes = [


  {
    path: '/',
    component: () => import('@/views/Index.vue'),
    meta: {
      title: '主页'
    },
    redirect: '/Home',
    children: [
      {
        path: '/Home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
      },
      // 基础资源管理
      {
        path: '/BasicResources',
        name: 'BasicResources',
        component: () => import('@/views/basicResources/BasicResources.vue'),
      },
      // 舆情分析
      {
        path: '/AnalysisPublic',
        name: 'AnalysisPublic',
        component: () => import('@/views/analysisPublic/AnalysisPublic.vue'),
      },
      // 车流监测
      {
        path: '/CarMonitoring',
        name: 'CarMonitoring',
        component: () => import('@/views/carMonitoring/CarMonitoring.vue'),
      },
      // 地理信息
      {
        path: '/GeographicInfo',
        name: 'GeographicInfo',
        component: () => import('@/views/geographicInfo/GeographicInfo.vue'),
      },
      // 景区详情
      {
        path: '/ScenicSpotDetails',
        name: 'ScenicSpotDetails',
        component: () => import('@/views/scenicSpotDetails/ScenicSpotDetails.vue'),
      },
      // 票务监测
      {
        path: '/TicketMonitoring',
        name: 'TicketMonitoring',
        component: () => import('@/views/ticketMonitoring/TicketMonitoring.vue'),
      },
      // 客流监测
      {
        path: '/CarMonitoring',
        name: 'CarMonitoring',
        component: () => import('@/views/carMonitoring/CarMonitoring.vue'),
      },
      // 视频监测
      {
        path: '/VideoMonitoring',
        name: 'VideoMonitoring',
        component: () => import('@/views/videoMonitoring/VideoMonitoring.vue'),
      },
    ]
  },

  {
    path: '/:catchAll(.*)',
    component: () => import('@/views/common/400.vue'),
    name: '400',
  },
  {
    path: '/Login',
    component: () => import('@/views/common/Login.vue'),
    name: 'Login',
  }
];
const router = createRouter({
  history: createWebHashHistory(),
  routes
});
export default router;

